import {t} from './i18n';
import * as shopify from './shopify.js';
import * as state from './state.js';
import {constants} from './constants.js';
import {isHomePage} from './helpers.js';

async function init() {
  registerListeners();
  await updatePrices();
}

function registerListeners() {
  if (document.getElementById('buy-logic-8') === null) {
    return;
  }  // nothing to register. (checkout)

  document.getElementById('buy-logic-8').addEventListener('click', () => {
    if (document.getElementById('logic-8-black').classList.contains('active')) {
      shopify.addItemToCart('SAL-00111');
    } else {
      shopify.addItemToCart('SAL-00112');
    }
  });

  document.getElementById('buy-logic-pro-8').addEventListener('click', () => {
    if (document.getElementById('logic-pro-8-black')
            .classList.contains('active')) {
      shopify.addItemToCart('SAL-00113');
    } else {
      shopify.addItemToCart('SAL-00114');
    }
  });

  document.getElementById('buy-logic-pro-16').addEventListener('click', () => {
    if (document.getElementById('logic-pro-16-black')
            .classList.contains('active')) {
      shopify.addItemToCart('SAL-00115');
    } else {
      shopify.addItemToCart('SAL-00116');
    }
  });

  document.getElementById('sal-cart').addEventListener('click', () => {
    if (isHomePage()) {
      shopify.navigateToCart();
    }
  });
}

async function updatePrices() {
  if (document.getElementById('logic-8-price') === null) {
    return;
  }  // nothing to register. (checkout)

  // ¥119,000
  // $999.00
  // €799,00
  // C$1,299.00
  // A$979.00
  // £719,00
  // NT$30,600
  // ¥7,988.00

  let l8 = await shopify.getPriceString('SAL-00111');
  let p8 = await shopify.getPriceString('SAL-00113');
  let p16 = await shopify.getPriceString('SAL-00115');

  if (l8.endsWith('.00') || l8.endsWith(',00')) l8 = l8.slice(0, -3);
  if (p8.endsWith('.00') || p8.endsWith(',00')) p8 = p8.slice(0, -3);
  if (p16.endsWith('.00') || p16.endsWith(',00')) p16 = p16.slice(0, -3);

  l8 = l8.replace(".","").replace(",","");
  p8 = p8.replace(".","").replace(",","");
  p16 = p16.replace(".","").replace(",","");

  document.getElementById('logic-8-price').textContent = l8;
  document.getElementById('logic-pro-8-price').textContent = p8;
  document.getElementById('logic-pro-16-price').textContent = p16;

  const currency = state.getCurrency();
  let exVats = document.querySelectorAll('.sal-ex-vat');
  if (currency === 'GBP' || currency === 'EUR') {
    exVats.forEach((exVat) => {
      exVat.textContent = t('js-ex-vat');
    });
  } else {
    exVats.forEach((exVat) => {
      exVat.textContent = '';
    });
  }
}



export {
  init,
  updatePrices,
};
